export enum FormFieldCategory {
    AUTHOR = 'AUTHOR_REGISTRATION',
    COPYRIGHT = 'COPYRIGHT',
    NO_SHOW = 'NO_SHOW',
    CUSTOM = 'CUSTOM'
}
